<script lang="ts">
    import Button from "@components/button/Button.svelte"
    import Popup from "@components/popup/Popup.svelte"
    import PopupBanner from "@components/popup/PopupBanner.svelte"
    import PopupButtons from "@components/popup/PopupButtons.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import PopupIcon from "@components/popup/PopupIcon.svelte"
    import PopupIconDivider from "@components/popup/PopupIconDivider.svelte"
    import { closeDialogue } from "./ConflictLessonPopup.svelte"
    import { openNotificationManager } from "./notifications-manager/NotificationManager.svelte"
    import { type NotificationDataType } from "@utils/practice/notifications-data"
    import { goto } from "$app/navigation"
    import { Day } from "@utils/practice/day-time"
    import { get } from "svelte/store"

    export let notfData: NotificationDataType
    export let lesson: number
    export let previous: number
    export let readingDone: boolean
    export let notificationsSetForPrevious: boolean | undefined | null

    async function processDeletingLessonReminders() {
        // TODO: set this logic
        // const notfStore = get(notificationStore)
        // if (notfStore) {
        // const notfNumber = notfStore.pendingLessonNumber
        // if (notfNumber !== null && notfNumber !== get(currentLessonNumber)) {
        //     // We have notfications set, but in the wrong lesson number - lets remove them
        //     await deleteUniqueLessonReminders()
        // }
    }

    // Don't delete lesson reminders, and we
    // don't update the device sync because
    // it's the same if we go backwards? (plus, resetLesson does it automatically)
    async function goBack(previousLesson: number) {
        await notfData.resetLesson(Day.fromToday(), previousLesson)
        // If we're closing dialogue, we need to see if we need to cancel current things
        await closeDialogue()
    }

    // Just exiting off the dialogue - basically
    // we are keeping the "new" lesson, so
    // we want to delete the lesson reminders
    async function simpleCancel() {
        await processDeletingLessonReminders()
        await notfData.syncThisDeviceLesson()
        await closeDialogue()
    }

    async function gotoPractice() {
        goto("/practice")
        await processDeletingLessonReminders()
        await notfData.syncThisDeviceLesson()
        await closeDialogue()
    }
</script>

<Popup on:clickoutside={simpleCancel}>
    <PopupBanner>
        <PopupExit on:exit={simpleCancel} float />
        <PopupIconDivider>
            <div slot="icon">
                <PopupIcon class="text-2xl dark:text-black bg-blue-100" icon="bell" />
            </div>
            <PopupHeading>Your practice lesson changed</PopupHeading>
        </PopupIconDivider>
    </PopupBanner>
    <p>
        You were on lesson <b>{previous}</b>, and another device moved practice to lesson
        <b>{lesson}</b>
        .
        <!-- </p>
    <p> -->
        You {readingDone ? "have completed" : "have not completed"} today's reading.
        {notificationsSetForPrevious
            ? "Changing lessons will cancel today's reminders on this device."
            : "No reminders are set on this device."}
    </p>
    <PopupButtons>
        {#if readingDone}
            <Button
                go={() => {
                    openNotificationManager(lesson)
                    return gotoPractice()
                }}>Set reminders for lesson {lesson}</Button
            >
        {:else}
            <Button go={gotoPractice}>Open lesson {lesson}</Button>
        {/if}
        <Button
            color="white"
            go={() => {
                return goBack(previous)
            }}
        >
            Return to lesson {previous}
        </Button>
    </PopupButtons>
</Popup>
